import { useState } from "react"
import { FilterMatchMode } from "primereact/api"

export const useFilters = () => {
  const initFilters = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    activity_type_hc: { value: null, matchMode: FilterMatchMode.CONTAINS },
    activity_name_hc: { value: null, matchMode: FilterMatchMode.CONTAINS },
    locations: { value: null, matchMode: FilterMatchMode.CONTAINS },
    referral_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    referral_status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    referral_entity_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    submittedBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
    facilitating_staff: { value: null, matchMode: FilterMatchMode.CONTAINS },
    document_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    topics: { value: null, matchMode: FilterMatchMode.CONTAINS },
    supervision_session_topic: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    facilitatingStaff: { value: null, matchMode: FilterMatchMode.CONTAINS },
    programs: { value: null, matchMode: FilterMatchMode.CONTAINS },
    date: { value: null, matchMode: FilterMatchMode.BETWEEN },
    organization_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    organization_names: { value: null, matchMode: FilterMatchMode.CONTAINS },
    staff_role_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    staff_primary_supervisor_name: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    program_id_gpra: { value: null, matchMode: FilterMatchMode.CONTAINS },
    program_id_status: { value: null, matchMode: FilterMatchMode.CONTAINS },
  }

  const [filters, setFilters] = useState(initFilters)

  const [globalFilterValue, setGlobalFilterValue] = useState("")
  const [globalFilterOrgValue, setGlobalFilterOrgValue] = useState("")
  const [globalFilterRoleValue, setGlobalFilterRoleValue] = useState("")
  const [globalFilterSupervisorValue, setGlobalFilterSupervisorValue] =
    useState("")

  const onGlobalFilterChange = (e) => {
    const value = e.target.value
    setGlobalFilterValue(value)
    setFilters((prevFilters) => ({
      ...prevFilters,
      global: { value, matchMode: FilterMatchMode.CONTAINS },
    }))
  }

  const clearGlobalFilter = () => {
    setGlobalFilterValue("")
    setFilters((prevFilters) => ({
      ...prevFilters,
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    }))
  }

  const onFilterChange = (field, value) => {
    setFilters((prevFilters) => {
      return {
        ...prevFilters,
        [field]: {
          ...prevFilters[field],
          value,
        },
      }
    })
  }

  const onMultiSelectFilterChange = (field, values) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: {
        ...prevFilters[field],
        value: values.length > 0 ? values : [], // verify that values is an array
        matchMode: "arrayContains", // we use custom matchMode for multiselects
      },
    }))
  }
  const onKeywordFilterChange = (field, e) => {
    const value = e.target.value
    setFilters((prevFilters) => {
      return {
        ...prevFilters,
        [field]: {
          ...prevFilters[field],
          value: value,
          matchMode: FilterMatchMode.CONTAINS,
        },
      }
    })
  }
  const clearAllFilters = () => {
    setGlobalFilterValue("")
    setGlobalFilterOrgValue("")
    setGlobalFilterRoleValue("")
    setGlobalFilterSupervisorValue("")
    setFilters(initFilters)
  }

  const onGlobalOrgFilterChange = (e) => {
    const value = e.value
    setGlobalFilterOrgValue(value)

    setFilters((prevFilters) => ({
      ...prevFilters,
      organization_name: { value, matchMode: FilterMatchMode.EQUALS },
    }))
  }

  const onGlobalRoleFilterChange = (e) => {
    const value = e.value
    setGlobalFilterRoleValue(value)

    setFilters((prevFilters) => ({
      ...prevFilters,
      staff_role_name: { value, matchMode: FilterMatchMode.EQUALS },
    }))
  }

  const onGlobalSupervisorFilterChange = (e) => {
    const value = e.value
    setGlobalFilterSupervisorValue(value)

    setFilters((prevFilters) => ({
      ...prevFilters,
      staff_primary_supervisor_name: {
        value,
        matchMode: FilterMatchMode.EQUALS,
      },
    }))
  }

  return {
    filters,
    globalFilterValue,
    globalFilterOrgValue,
    globalFilterRoleValue,
    globalFilterSupervisorValue,
    onGlobalFilterChange,
    clearGlobalFilter,
    onFilterChange,
    clearAllFilters,
    onGlobalOrgFilterChange,
    onGlobalRoleFilterChange,
    onGlobalSupervisorFilterChange,
    onKeywordFilterChange,
    onMultiSelectFilterChange,
  }
}
